"use strict";

let recruitment = require("@/node-sdk/recruitment/app.js");
let project = require("@/node-sdk/project/app.js");
let product = require("@/node-sdk/product/app.js");
let repository = require("@/node-sdk/repository/app.js");
let global = require("@/node-sdk/global/app.js");
let email = require("@/node-sdk/email/app.js");
let commercial = require("@/node-sdk/commercial/app.js");
let form = require("@/node-sdk/form/app.js");
const Project = require("./resource/project.js");
const Recruitment = require("./resource/recruitment.js");
const App = require("./resource/app.js");
const Sirh = require("./resource/sirh.js");
const Ticket = require("./resource/ticket.js");
const Folder = require("./resource/folder.js");
const Product = require("./resource/product.js");
const Crm = require("./resource/crm.js");
const Notif = require("./resource/notif.js");
const History = require("./resource/history.js");
const Payment = require("./resource/payment.js");
const Event = require("./resource/event.js");
const Accounting = require("./resource/accounting.js");

module.exports.Hk = {
  Project,
  Recruitment,
  App,
  Sirh,
  Ticket,
  Folder,
  Product,
  Crm,
  Notif,
  History,
  Payment,
  Event,
  Accounting,
};

module.exports.Form = form.Form;
module.exports.Recruitment = recruitment.Recruitment;
module.exports.Pipeline = recruitment.Pipeline;
module.exports.Filter_cvtech = recruitment.Filter_cvtech;
module.exports.Filter_recruitment = recruitment.Filter_recruitment;
module.exports.Apply = recruitment.Apply;
module.exports.Cvtech = recruitment.Cvtech;
module.exports.Action = recruitment.Action;
module.exports.Note = recruitment.Note;
module.exports.Career = recruitment.Career;
module.exports.State = recruitment.State;
module.exports.State_recruitment = recruitment.State_recruitment;
module.exports.Folder = recruitment.Folder;
module.exports.State_folder = recruitment.State_folder;
module.exports.Interview = recruitment.Interview;
module.exports.Diffusion = recruitment.Diffusion;
module.exports.Diffusion_category = recruitment.Diffusion_category;
module.exports.Diffusion_choice = recruitment.Diffusion_choice;
module.exports.Tech = recruitment.Tech;
module.exports.Tech_category = recruitment.Tech_category;
module.exports.Tech_choice = recruitment.Tech_choice;
module.exports.Label = recruitment.Label;
module.exports.Label_category = recruitment.Label_category;
module.exports.Label_choice = recruitment.Label_choice;
module.exports.User_me = recruitment.User_me;
module.exports.User = recruitment.User;
module.exports.Comment = recruitment.Comment;
module.exports.Cvtech_document = recruitment.Cvtech_document;
module.exports.Cvtech_cover_letter = recruitment.Cvtech_cover_letter;
module.exports.Recruitment_company_banner =
  recruitment.Recruitment_company_banner;
module.exports.Recruitment_company_image =
  recruitment.Recruitment_company_image;
module.exports.Recruitment_team = recruitment.Recruitment_team;
module.exports.Email = recruitment.Email;
module.exports.Graph = recruitment.Graph;

module.exports.Project = project.Project;
module.exports.Step = project.Step;
module.exports.Task = project.Task;
module.exports.LabelProject = project.LabelProject;
module.exports.ToDoList = project.ToDoList;
module.exports.ToDoStates = project.ToDoStates;
module.exports.Comment = project.Comment;
module.exports.Topic = project.Topic;
module.exports.Workload = project.Workload;
module.exports.DashboardProject = project.DashboardProject;

module.exports.Delivery = product.Delivery;
module.exports.Manufacturer_note = product.Manufacturer_note;
module.exports.Manufacturer_document = product.Manufacturer_document;
module.exports.Manufacturer = product.Manufacturer;
module.exports.Product_variation = product.Product_variation;
module.exports.Product_pack_item = product.Product_pack_item;
module.exports.Product_pack = product.Product_pack;
module.exports.Product = product.Product;
module.exports.Delivery_line = product.Delivery_line;
module.exports.Delivery_note = product.Delivery_note;
module.exports.Delivery_document = product.Delivery_document;
module.exports.Order = product.Order;
module.exports.Purchase_order = product.Purchase_order;
module.exports.Stockage_area = product.Stockage_area;
module.exports.Client_delivery = product.Client_delivery;
module.exports.Client_delivery_document = product.Client_delivery_document;
module.exports.Client_delivery_note = product.Client_delivery_note;
module.exports.Receipt = product.Receipt;
module.exports.Receipt_document = product.Receipt_document;
module.exports.Receipt_note = product.Receipt_note;
module.exports.Price = product.Price;
module.exports.Stock_movement = product.Stock_movement;
module.exports.Order_return = product.Order_return;
module.exports.Service = product.Service;

module.exports.Contact = repository.Contact;
module.exports.Organization = repository.Organization;
module.exports.Organization_document = repository.Organization_document;
module.exports.Organization_note = repository.Organization_note;
module.exports.Contact_note = repository.Contact_note;
module.exports.Contact_document = repository.Contact_document;

module.exports.APIRequest = global.APIRequest;
module.exports.FunctionHelpers = global.FunctionHelpers;
module.exports.Reporting = global.Reporting;

module.exports.TemplateEmail = email.TemplateEmail;

module.exports.PipelineCrm = commercial.PipelineCrm;
module.exports.PipelineTeam = commercial.PipelineTeam;
module.exports.StateCrm = commercial.StateCrm;
module.exports.BusinessOpportunity = commercial.BusinessOpportunity;
module.exports.Quotation = commercial.Quotation;
module.exports.QuotationLine = commercial.QuotationLine;
module.exports.Invoice = commercial.Invoice;
module.exports.InvoiceLine = commercial.InvoiceLine;
module.exports.InvoicePayment = commercial.InvoicePayment;
module.exports.Credit = commercial.Credit;
module.exports.CreditLine = commercial.CreditLine;
module.exports.CreditPayment = commercial.CreditPayment;
module.exports.PersonalOrganization = commercial.PersonalOrganization;
module.exports.Activity = commercial.Activity;
module.exports.ReportingCrm = commercial.ReportingCrm;
module.exports.DashboardCrm = commercial.DashboardCrm;
module.exports.LabelRule = commercial.LabelRule;
